import Enum from '/@/modules/core/app/helpers/Enum';

export class EstateHealthCheckStatus extends Enum {
    static NOT_STARTED: string = 'not_started';
    static IN_PROGRESS: string = 'in_progress';
    static COMPLETED: string = 'completed';
    static WAITING_FOR_PARTNER_REVIEW: string = 'waiting_for_partner_review';
}
